import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import getLocale from '../../i18n/getLocale';

class ScheduledPlanningAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      extra_crew: false,
      loaded: 0,
      base_id: null,
      aircraft_id: null,
      import: null,
      date: '',
      bases_select: [],
      aircrafts_select: [],
      contracts_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // Handlers
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.setState({contract_id: null, aircraft_id: null});
    this.setState(change);
  }
  

  //Ao trocar aeronava, listamos contratos da mesma..
  handleSelectAircraftChange(name, event) {
    var change = {};
    var self = this;
    change['contract_id'] = null;
    if(event == null) {
      change[name] = null;
      self.setState({ contracts_select: [] });
    } else {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/contrato/aeronave/select/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.setState({
              contracts_select: responseJson.data,
            });
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }); /* Overlay */
      });
    }
    this.setState(change);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao/info/cadastro', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({bases_select: responseJson.data.bases_select});
          self.setState({aircrafts_select: responseJson.data.aircrafts_select});
          self.setState({date: responseJson.data.date});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      contract_id: this.state.contract_id,
      aircraft_id: this.state.aircraft_id,
      extra_crew: this.state.extra_crew,
      base_id: this.state.base_id,
      date: this.state.date,
      import: this.state.import,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/programacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/escala/programacao/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Escalas.AdicionarEscalaDiaria.titulo}</h3>
      <Link to="/escalas/programacao" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Escalas.AdicionarEscalaDiaria.formulario.Data}:</label>
              <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Escalas.AdicionarEscalaDiaria.formulario.Base}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={''}
                required
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_select}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Escalas.AdicionarEscalaDiaria.formulario.TripulacaoExtra}:</label>
              <br />
              <Toggle
                checked={this.state.extra_crew}
                aria-label='No label tag'
                name="extra_crew"
                onChange={this.handleToggleChange.bind(this, 'extra_crew')}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Escalas.AdicionarEscalaDiaria.formulario.Prefixo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={''}
                required
                disabled={this.state.extra_crew == true ? true : false}
                onChange={this.handleSelectAircraftChange.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_select}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Escalas.AdicionarEscalaDiaria.formulario.Contrato}:</label>
              <Select
                className="form-field-name"
                name="contract_id"
                value={this.state.contract_id}
                searchable={true}
                placeholder={''}
                disabled={this.state.extra_crew == true ? true : false}
                onChange={this.handleSelectChange.bind(this, 'contract_id')}
                options={this.state.contracts_select}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Escalas.AdicionarEscalaDiaria.formulario.botaoSalvarProgramacao}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ScheduledPlanningAdd;



// WEBPACK FOOTER //
// ./src/Components/Schedules/SchedulePlanningAdd.js